import type { RootState } from 'state';
import type { WebsitesState } from '../slice';

function getWebsites(state: RootState): WebsitesState['value'] {
  const { value } = state.dataService.websites.websites;
  return value;
}

export default getWebsites;
